import {
  TSession,
  TSessionFormat,
} from '@fe-learner-common/api/schemas/sessionsSchema';
import { useIntl } from 'react-intl';

export const formatTextsMap: Record<TSessionFormat, string> = {
  face2face: 'catalog.format.classroom',
  online: 'catalog.format.online',
  hybrid: 'catalog.format.hybrid',
};

export const useSessionTranslations = (session: TSession) => {
  const intl = useIntl();
  return {
    format: session.format
      ? intl.formatMessage({ id: formatTextsMap[session.format] })
      : '',
  };
};
